import { render, staticRenderFns } from "./AcademicMonitorSchedule.vue?vue&type=template&id=4b42bf49&scoped=true"
import script from "./AcademicMonitorSchedule.vue?vue&type=script&lang=js"
export * from "./AcademicMonitorSchedule.vue?vue&type=script&lang=js"
import style0 from "./AcademicMonitorSchedule.vue?vue&type=style&index=0&id=4b42bf49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b42bf49",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VForm,VListItemContent,VListItemSubtitle,VListItemTitle,VTextField})
